import { render, staticRenderFns } from "./PortalSignUp.vue?vue&type=template&id=6120bc3f&scoped=true&"
import script from "./PortalSignUp.vue?vue&type=script&lang=js&"
export * from "./PortalSignUp.vue?vue&type=script&lang=js&"
import style0 from "./PortalSignUp.vue?vue&type=style&index=0&id=6120bc3f&prod&lang=scss&scoped=true&"
import style1 from "./PortalSignUp.vue?vue&type=style&index=1&id=6120bc3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120bc3f",
  null
  
)

export default component.exports